export default __webpack_public_path__ + "static/media/giftVoucher.c084fe95.svg";